import { getArTableList } from "./graphAppInfoCheckFunctions";
import { checkGraphResponse } from "./GraphMain";
import { accessInfoType } from "../utils/classInfos";
import { getNormalizedElementTypeId, getAsJson, isEmailAddress, isSameText, getJsonFromCompression } from "../utils/helper";
import { getOptimizedCellAddress } from "../utils/helperExcel";
import store from "./StoreRoot";

async function getElementInfoRows(helperTables, sessionId, fileUrl, client, additionalRequests) {
  console.count("INFO getElementInfoRows");
  // get the table object
  if (!helperTables) {
    helperTables = await getArTableList(fileUrl, sessionId, client);
  }
  // build the batch request
  let requests = [];
  let filterUrl = fileUrl + "/workbook/tables/AR_INFO/rows"; // ?$filter=startswith(givenName,'J')
  if (helperTables.includes("AR_INFO")) {
    requests.push({
      url: filterUrl,
      method: "GET",
      id: "INFO",
      headers: {
        "workbook-session-id": sessionId
      }
    })
  }
  // add additional requests to this batch
  if (additionalRequests) {
    additionalRequests.forEach((item) => {
      requests.push(item);
    });
  }
  // run the batch
  if (requests.length > 0) {
    const $batch = { requests: requests };
    // console.time("zzz get info table");
    let res = await client
      .api("/$batch")
      .post($batch);
    // console.timeEnd("zzz get info table");

      checkGraphResponse(res, "getInfoTables");
      return res;
  }
}

export async function getElementAppInfo(
  accessInfo: accessInfoType,
  elementId: string,
  elementType: string,
  sessionId: string,
  fileUrl: string,
  client: any,
  tables: any[]
) {
  const normalizedElementId = getNormalizedElementTypeId(elementId, elementType);
  let isOwner = accessInfo.driveItemInfo.shareType === "owner";
  let documentHeader = undefined;
  let documentFooter = undefined;
  let documentOwner = undefined;
  let userParameters = undefined;
  let helperTables = tables;
  // let views = [];
  // let calculations = [];
  let userRoles = (isOwner) ? ["admin"] : [];
  let batchRes = await getElementInfoRows(helperTables, sessionId, fileUrl, client, null );

  if (batchRes?.responses) {

    // get the INFO table
    let appInfoTable = batchRes.responses[batchRes.responses.findIndex((x) => x.id === "INFO")];
    if (appInfoTable?.body?.value) {
      try {
        appInfoTable.body.value.forEach((tempValue) => {
          const tempRow = tempValue.values[0];
          const tempType = tempRow[0];
          if (tempType === normalizedElementId + "_header") {
            documentHeader = tempRow[1];
          }
          if (tempType === normalizedElementId + "_footer") {
            documentFooter = tempRow[1];
          }
          if (tempType === normalizedElementId + "_parameters") {
            userParameters = getAsJson(tempRow[1]);
          }          
          if (tempType === "document_owner") {
            documentOwner = tempRow[1];
          }
          // if (tempType.includes("view_") && !tempType.includes("_header")) {
          //   views.push({ info: tempRow[1]});
          // }
          // if (tempType.includes("calculation_") && !tempType.includes("_header")) {
          //   calculations.push({ info: tempRow[1]});
          // }
        })
        // is owner
        if (isEmailAddress(documentOwner)) {
          if (!isSameText(documentOwner, store.main.userMe?.mail)) {
            userRoles = ["user"];
          }
        }
      } catch (err) { 
        console.log("ERROR get appInfoTable", err);
      }
    }
    // user parameters default
    if (!userParameters) {
      if (["range","sheet","table"].includes(elementType)) {
        userParameters = {};
        // userParameters = {
        //   showHeaders: true,
        //   showGridLines: true,
        //   hiddenColumns: { columns: [], indicators: false },
        //   hiddenRows: { rows: [], indicators: false },
        //   editCells: [],
        //   height: null
        // }
      }
    }
  }
  // appInfo
  let appInfo = { 
    documentHeader,
    documentFooter,
    documentOwner,
    userParameters,
    userRoles,
  };
  // let useCalculationsList = (elementType !== "calculation");
  // let useViewsList = (elementType !== "calculation");
  // if (useViewsList) appInfo["views"] = views;
  // if (useCalculationsList) appInfo["calculations"] = calculations;
  return appInfo;
}

export async function getViewInfoForElement(
  elementId: string,
  elementType: string,
  sessionId: string,
  fileUrl: string,
  client: any,
) {
  const normalizedElementId = getNormalizedElementTypeId(elementId, elementType);
  let viewInfo = undefined;
  let batchRes = await getElementInfoRows(null, sessionId, fileUrl, client, null );
  if (batchRes) {
    // get the INFO table
    let appInfoTable = batchRes.responses[batchRes.responses.findIndex((x) => x.id === "INFO")];
    if (appInfoTable) {
      try {
        appInfoTable.body?.value?.forEach((tempValue) => {
          const tempRow = tempValue.values[0];
          const tempType = tempRow[0];
          if (tempType === normalizedElementId) {
            let infoCell = tempRow[1] ?? "";
            let infoCell2 = tempRow[2] ?? "";
            let infoCell3 = tempRow[3] ?? "";
            let infoCell4 = tempRow[4] ?? "";
            let infoCell5 = tempRow[5] ?? "";
            let infoCell6 = tempRow[6] ?? "";
            infoCell = infoCell + infoCell2 + infoCell3 + infoCell4 + infoCell5 + infoCell6;
            viewInfo = getJsonFromCompression(infoCell);
            console.log("INFO viewInfo size", viewInfo.length);
          }
        })
      } catch (err) { 
        console.log("ERROR getViewInfoForElement", err);
      }
    }
  }

  return viewInfo;
}

export async function getCalculationInfoForElement(
  accessInfo: accessInfoType,
  elementId: string,
  elementType: string,
  sessionId: string,
  fileUrl: string,
  client: any
) {
  const normalizedElementId = getNormalizedElementTypeId(elementId, elementType);
  let calculationInfo = undefined;
  let additionalRequests = [{
    url: fileUrl + "/workbook/names",
    method: "GET",
    id: "NAMES",
    headers: {
      "workbook-session-id": sessionId
    }
  }];
  let batchRes = await getElementInfoRows(null, sessionId, fileUrl, client, additionalRequests );
  if (batchRes) {

    //===========================
    // get the INFO object
    //===========================

    let appInfoTable = batchRes.responses[batchRes.responses.findIndex((x) => x.id === "INFO")];
    if (appInfoTable) {
      try {
        appInfoTable.body?.value?.forEach((tempValue) => {
          const tempRow = tempValue.values[0];
          const tempType = tempRow[0];
          if (tempType === normalizedElementId) {
            let infoCell = tempRow[1] ?? "";
            let infoCell2 = tempRow[2] ?? "";
            let infoCell3 = tempRow[3] ?? "";
            let infoCell4 = tempRow[4] ?? "";
            let infoCell5 = tempRow[5] ?? "";
            let infoCell6 = tempRow[6] ?? "";
            infoCell = infoCell + infoCell2 + infoCell3 + infoCell4 + infoCell5 + infoCell6;

            calculationInfo = getJsonFromCompression(infoCell);
            console.log("INFO calculationInfo size", infoCell.length);
          }
        })
      } catch (err) { 
        console.log("ERROR getCalculationInfoForElement", err);
      }
    }

    //===========================
    // get the NAMES list
    //===========================

    let names = [];
    let tempNames = batchRes.responses[batchRes.responses.findIndex((x) => x.id === "NAMES")];
    if (checkGraphResponse(tempNames, "getCalculationInfoForElement.names")) {
      tempNames.body.value?.forEach((tempName) => {
        // look for collaboration
        const elementId = tempName.name.toLowerCase();
        const elementType = tempName.type.toLowerCase();

        if (elementType === "range") {
          names.push({
            id: elementId,
            name: tempName.comment || tempName.name,
            address: getOptimizedCellAddress(tempName.value)
          });
        }
      });
    };
    // add it to the calculation object
    if (names.length > 0) {
      if (!calculationInfo) calculationInfo = {};
      calculationInfo["names"] = names;
    }
  }
  return calculationInfo;
}
